import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PoliticaCookies = () => {
  return (
    <div className="bg-white min-h-screen">
      <Header />
      <main className="pt-28 pb-16">
        <div className="container mx-auto px-6 lg:px-10 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            Política de Cookies
          </h1>

          <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Información General de las cookies</h2>
              <p>
                La confianza del usuario es importante para nosotros, y por consiguiente, en <strong>TALLERES MICROBAT, SL</strong> nos preocupa proteger su privacidad. Un aspecto importante de esto es proporcionarle toda la información posible sobre cómo utilizamos sus datos de carácter personal, incluso cómo utilizamos el almacenamiento local de datos y tecnología similar.
              </p>
              <p>
                El almacenamiento local de datos implica almacenar diferentes tipos de datos localmente en su dispositivo a través de su navegador web. Los datos almacenados localmente pueden, por ejemplo, contener la configuración del usuario, información sobre cómo navega por nuestro sitio web, qué navegador web utiliza, qué anuncios se han mostrado, y el comportamiento similar en sitios web con los que colaboramos. Los datos almacenados localmente pueden ser utilizados para personalizar el contenido y las funciones en nuestros servicios de forma que sus visitas sean más cómodas y tengan más sentido.
              </p>
              <p>
                Un método de almacenamiento local de datos son las cookies. Las cookies son pequeños archivos de texto que se almacenan en su dispositivo (PC, teléfono móvil o tableta) que nos permiten reconocer su navegador web. Las cookies contienen información principalmente sobre su navegador web y sobre cualquier actividad que se ha producido en él. Nos ayudan a garantizar la seguridad y el funcionamiento óptimo de nuestro sitio web.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Información complementaria de las cookies</h2>
              <p>
                Utilizamos el almacenamiento local de datos para una serie de fines, tales como: permitirnos realizar nuestros servicios; aportarle contenido pertinente y personalizado cuando visita nuestros sitios web; medir y analizar el tráfico en nuestro sitio web; mejorar nuestros servicios; y dirigir publicidad específica.
              </p>
              
              <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3">Para nuestra publicidad</h3>
              <p>
                Utilizamos el almacenamiento local de datos en relación con las actividades publicitarias. Esto nos permite saber si y con qué frecuencia el usuario ha visto un anuncio o determinado tipo de anuncio, y cuánto tiempo hace que lo vio. También utilizamos el almacenamiento local de datos para construir segmentos y grupos objetivo con fines de marketing y para dirigir anuncios específicos.
              </p>

              <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3">Para analizar y mejorar nuestros servicios</h3>
              <p>
                Utilizamos diversas herramientas de medición que nos proporcionan estadísticas y análisis relativos a nuestros servicios. Estas herramientas nos permiten reconocer el navegador web a lo largo del tiempo y averiguar si el usuario ha visitado el sitio web anteriormente y si es así con qué frecuencia. Estas herramientas nos ofrecen la posibilidad de lograr una visión general de cuántos usuarios únicos tenemos y cómo utilizan nuestros servicios.
              </p>

              <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3">Para entregar y adaptar los servicios a su uso</h3>
              <p>
                Se requiere y es necesario el almacenamiento local de datos con el fin de permitirle utilizar nuestros servicios, tales como información sobre su configuración, que nos dice cómo deben presentarse los servicios en su navegador web. También utilizamos el almacenamiento local de datos para adaptar nuestros servicios a su uso lo mejor posible.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Gestión de las cookies</h2>
              <p>
                Puede desactivar las cookies o configurar su navegador para que le avise cuando le envían una cookie.
              </p>
              <p>
                La configuración en su navegador web normalmente muestra una lista de todas las cookies que han sido almacenadas para proporcionarle una visión general y, si lo desea, para eliminar las cookies no deseadas. Normalmente, puede indicar que acepta el almacenamiento de cookies de los sitios web que visita o de terceros afiliados a dichos sitios web. También puede escoger ser notificado cada vez que se almacena una nueva cookie.
              </p>
              <p>
                Tenga en cuenta que si usted las desactiva, es posible que no pueda disfrutar de todas las funcionalidades de nuestro sitio web.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Gestión de cookies en Google Chrome</h2>
              <p><strong>Cómo eliminar cookies:</strong></p>
              <ol className="list-decimal pl-6 space-y-1">
                <li>Ve a Configuración en el menú de su navegador.</li>
                <li>Haz clic en Mostrar configuración avanzada.</li>
                <li>Haz clic en Eliminar datos de navegación.</li>
                <li>Selecciona el período de tiempo para el que deseas eliminar la información.</li>
                <li>Marca Cookies y otros datos de sitios y complementos.</li>
                <li>Haz clic en Borrar datos de navegación.</li>
              </ol>
              <p className="mt-4"><strong>Cómo evitar que las cookies se almacenen:</strong></p>
              <ol className="list-decimal pl-6 space-y-1">
                <li>Ve a Configuración en el menú de tu navegador.</li>
                <li>Haz clic en Mostrar configuración avanzada y después en Configuración de contenido.</li>
                <li>En Cookies, selecciona tu opción preferida.</li>
                <li>Haz clic en Hecho.</li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Gestión de cookies en Safari</h2>
              <p><strong>Cómo eliminar cookies:</strong></p>
              <ol className="list-decimal pl-6 space-y-1">
                <li>Ir a Preferencias en el menú de su navegador.</li>
                <li>Haz clic en la pestaña Privacidad.</li>
                <li>Haz clic en Eliminar todos los datos de los sitios web.</li>
              </ol>
              <p className="mt-4"><strong>Cómo evitar que las cookies se almacenen:</strong></p>
              <ol className="list-decimal pl-6 space-y-1">
                <li>Ir a Preferencias en el menú de tu navegador.</li>
                <li>Haz clic en la pestaña Privacidad.</li>
                <li>En Cookies y datos de sitios web selecciona tu opción preferida.</li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Gestión de cookies en Mozilla Firefox</h2>
              <p><strong>Cómo eliminar cookies:</strong></p>
              <ol className="list-decimal pl-6 space-y-1">
                <li>Ir a Opciones en el menú de su navegador.</li>
                <li>Haz clic en la pestaña Privacidad.</li>
                <li>Haz clic en Mostrar cookies.</li>
                <li>Selecciona las cookies que deseas eliminar y haz clic en Eliminar seleccionadas.</li>
              </ol>
              <p className="mt-4"><strong>Cómo evitar que las cookies se almacenen:</strong></p>
              <ol className="list-decimal pl-6 space-y-1">
                <li>Ir a Configuración en el menú de tu navegador.</li>
                <li>Selecciona la pestaña Privacidad.</li>
                <li>En Historial, haz clic en Usar una configuración personalizada para el historial.</li>
                <li>Selecciona tus opciones preferidas en Permitir cookies de sitios web.</li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Gestión de cookies en Internet Explorer</h2>
              <p><strong>Cómo eliminar cookies:</strong></p>
              <ol className="list-decimal pl-6 space-y-1">
                <li>Ir a Herramientas (icono de rueda dentada) en el menú de tu navegador.</li>
                <li>Haz clic en Propiedades de Internet.</li>
                <li>En la pestaña General - Historial de navegación, haz clic en Eliminar.</li>
                <li>Asegúrate de marcar la opción Cookies y datos de sitios web.</li>
                <li>Haz clic en Eliminar.</li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Información de contacto</h2>
              <p>
                Para mayor transparencia, si tiene alguna pregunta relativa al uso del almacenamiento local de nuestro sitio web, póngase en contacto con nosotros en <a href="mailto:microbat@microbat.es" className="text-[#0d3b66] hover:underline">microbat@microbat.es</a>, indicando en el asunto "Política de cookies".
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PoliticaCookies;
